//@flow
import { HiverAxios, showMessage } from 'h-commons';
import {
    GET_BILLING_CONTACT_DETAILS_DONE,
    GET_BILLING_CONTACT_DETAILS_INIT,
    GET_BILLING_CONTACT_DETAILS_FAILED,
    UPDATE_BILLING_CONTACT_DETAILS_DONE,
    UPDATE_BILLING_CONTACT_DETAILS_INIT,
    UPDATE_BILLING_CONTACT_DETAILS_FAILED
} from './types';

export const billingContactDetails = (update: ?boolean, data: ?Object) => (dispatch: Function) => {
    dispatch({
        type: update ? UPDATE_BILLING_CONTACT_DETAILS_INIT : GET_BILLING_CONTACT_DETAILS_INIT
    });
    HiverAxios({
        url: '/api/account/billingContacts',
        type: update ? 'POST' : 'GET',
        params: data,
        callback: response => {
            if (response.data && response.data.success) {
                dispatch({
                    type: update ? UPDATE_BILLING_CONTACT_DETAILS_DONE : GET_BILLING_CONTACT_DETAILS_DONE,
                    payload: response.data.data
                });
                if (update) {
                    dispatch(billingContactDetails(false));
                    showMessage({ message: 'Billing contact details updated successfully', type: 'success' });
                }
            } else {
                dispatch({
                    type: update ? UPDATE_BILLING_CONTACT_DETAILS_FAILED : GET_BILLING_CONTACT_DETAILS_FAILED
                });
                if(update) {
                    showMessage({ message: 'Max/Min limit of billing contacts encountered', type: 'error' });
                }
            }
        },
        onfail: err => {
            console.error(err);
            dispatch({
                type: update ? UPDATE_BILLING_CONTACT_DETAILS_FAILED : GET_BILLING_CONTACT_DETAILS_FAILED
            });
            if(update) {
                showMessage({ message: 'Max/Min limit of billing contacts encountered', type: 'error' });
            }
        }
    })
}